export default __webpack_public_path__ + "static/media/logo-white.74425b84.png";